export default "__VITE_ASSET__a7f24ede__"